import UPTab from 'components/tab';
import { UPTabSection } from 'components/tab/types';
import { ConfigurationDomain } from 'constants/ConfigurationDomain';
import { useTranslation } from 'react-i18next';
import { MANAGEMENT__CONTRACT_VALIDATION_COMPLIANCE } from 'translations/constants';
import { getConfigurationDomain } from '../domains';
import BreakHoursForMinors from './break-hours';
import NightWorkForMinors from './night-work';
import PlanningInThePast from './planning-in-the-past';
import { ContractComplianceTab } from './routes';
import { ContractComplianceBody, ContractComplianceContainer, ContractComplianceTitle } from './styles';

/** Content of each tab; the tab list and its labels come from the domain definition, shared with the breadcrumbs. */
const TAB_CONTENT: Record<string, JSX.Element> = {
  [ContractComplianceTab.NIGHT_WORK_FOR_MINORS]: (
    <NightWorkForMinors key={ContractComplianceTab.NIGHT_WORK_FOR_MINORS} />
  ),
  [ContractComplianceTab.BREAK_HOURS_FOR_MINORS]: (
    <BreakHoursForMinors key={ContractComplianceTab.BREAK_HOURS_FOR_MINORS} />
  ),
  [ContractComplianceTab.PLANNING_IN_THE_PAST]: <PlanningInThePast key={ContractComplianceTab.PLANNING_IN_THE_PAST} />,
};

/**
 * "Contract validation & compliance" configuration domain. Each sub-area is a tab with its own URL segment,
 * like the Joint commissions domain.
 */
const ContractCompliance = (): JSX.Element => {
  const [t] = useTranslation();
  const subSections = getConfigurationDomain(ConfigurationDomain.CONTRACT_VALIDATION_COMPLIANCE)?.subSections ?? [];

  const sections: UPTabSection[] = subSections.map(section => ({ title: t(section.labelKey), route: section.key }));

  return (
    <ContractComplianceContainer data-testid="contract-compliance">
      <ContractComplianceTitle>{t(MANAGEMENT__CONTRACT_VALIDATION_COMPLIANCE)}</ContractComplianceTitle>
      {/* UPTab takes one child per section, in the same order. */}
      <ContractComplianceBody hasTabs>
        <UPTab sections={sections}>{subSections.map(section => TAB_CONTENT[section.key])}</UPTab>
      </ContractComplianceBody>
    </ContractComplianceContainer>
  );
};

export default ContractCompliance;
